import { useMemo } from "react";
import {
  PocAssignee,
  PocAssigneeLabels,
} from "../../../../../enums/pocAssignee";

export interface PocNameOption {
  /** Display name, e.g. "Tanmay". */
  label: string;
  /** Stored POC id (Firebase UID). */
  value: string;
}

/**
 * Builds the POC dropdown options for the Add New User modal.
 *
 * Options come from the POC assignee roster (id → display name), unioned with
 * any POC ids already present in the table so existing values stay selectable.
 *
 * @param existingPocs - POC ids already present in the loaded rows.
 * @returns Options shaped as { label: name, value: id }.
 */
export function usePocNameOptions(existingPocs: string[]): PocNameOption[] {
  return useMemo(() => {
    const roster: PocNameOption[] = Object.values(PocAssignee).map((id) => ({
      value: id,
      label: PocAssigneeLabels[id],
    }));
    const known = new Set(roster.map((option) => option.value));
    const extras: PocNameOption[] = Array.from(
      new Set(existingPocs.filter((poc) => poc && !known.has(poc))),
    ).map((id) => ({ value: id, label: id }));
    return [...roster, ...extras];
  }, [existingPocs]);
}
